












import { Component, Prop, Vue } from 'vue-property-decorator'
import { ExtendedRouteConfig } from '@/types/routing-types'


@Component
export default class NavigationItem extends Vue {
    @Prop() route !: ExtendedRouteConfig
}
